import { PureComponent, type ReactNode } from "react";

export type NavbarProps = {
  children?: ReactNode;
};

export class Navbar extends PureComponent<NavbarProps> {
  render(): ReactNode {
    return (
      <div className="w-full py-2 shadow fixed relative z-20 overflow-hidden">
        <div className="container w-full h-12 md:h-14 flex items-center justify-between">
          {this.props.children}
        </div>
      </div>
    );
  }
}
